/* eslint-disable max-len */
export default {
  cfmoto: {
    AIReview: 'AI审核',
    AIReviewFailed: 'AI审核不通过',
    AIReviewPassed: 'AI审核通过',
    AIReviewStatus: 'AI审核状态',
    AIReviewing: 'AI审核中',
    America: '美国',
    CheckSupportInstall: '检测是否支持加装',
    ImporterCommunityDisplayName: '进口商社区展示名称',
    ImporterContactEmail: '进口商联系邮箱',
    IndicatorLight: '辅助指示器',
    Instruction: '须知',
    MostPicture4OrVideo: '(最多4张图片/1个视频)',
    PleaseContactPersonnelCommunicating: '请联系CFMOTO对接人员',
    Redemptionservice: '兑换服务',
    USD: '美元',
    UnbindingApplicationCommitment: '解绑申请承诺书',
    aboutAccount: '关于账号',
    aboutVehicle: '关于车辆',
    accountApplyRejected: '账户删除申请已拒绝',
    accountCancel: '账户删除申请',
    accountDeletExplain: '账户删除说明',
    accountDelete: '账户删除',
    accountDeleted: '账户已删除',
    accountFormatError: '账号格式错误 / 用户不存在 ，需根据实际原因匹配对应文案',
    accountNumber: '账号',
    action: '操作',
    actionFail: '操作失败',
    actionSuccess: '操作成功',
    activeScore: '主动评分',
    activeTrigger: '用户主动触发（关于APP—去评分）',
    activity: '活动',
    activityCancel: '活动取消',
    activityCover: '活动封面',
    activityDetails: '活动详情',
    activityId: '活动ID',
    activityList: '活动列表',
    activityManagement: '活动管理',
    activitySearch: '活动查询',
    activityTime: '活动时间',
    activityTitle: '活动标题',
    activityVenue: '活动地点',
    adaptable: '适用车型',
    add: '添加',
    addAccountDeletExplain: '新增账户删除说明',
    addAuthenticationTime: '添加认证时间',
    addCanadaPrivacyPolicy: '新增加拿大隐私政策',
    addCanadaTelematicsPolicy: '新增加拿大远程服务处理协议',
    addCanadaUserPolicy: '新增加拿大用户协议',
    addDashcamHelp: '新增行车记录仪帮助',
    addDataDeletExplain: '新增数据删除说明',
    addEmail: '新增邮件',
    addExhibitionCategory: '新增展厅分类',
    addExhibitionSeries: '新增系列',
    addHelpConfiguration: '新增帮助说明配置',
    addInformationCategory: '新增资讯类别',
    addInformationContent: '新增资讯内容',
    addKolUserAuthentication: '添加KOL用户认证',
    addPicture: '新增图片',
    addPrivacyAgreement: '新增隐私政策',
    addPrivacySubmitSure: '新增隐私政策的生效日期及变更说明提交后不可调整，确认提交',
    addPushConfiguration: '新增推送配置',
    addQuestion: '新增问题',
    addSdkStaement: '新增SDK说明',
    addServiceIntroduce: '新增服务介绍',
    addShowroomModel: '新增展厅车型',
    addThisUser: '添加该用户',
    addTopic: '添加话题',
    addUser: '添加用户',
    addUserAgreement: '新增用户协议',
    addUserRole: '新增用户角色',
    addVehicleModel: '新增车型',
    addVehicleModelCategory: '新增车型类别',
    addVideo: '新增视频',
    addedBy: '添加人',
    additionalFeedback: '补充反馈',
    administratorUnbind: '管理员解绑',
    afternoon: '下午',
    agreeServiceAgreement: '开通服务即视为同意服务协议',
    agreeSignOut: '同意注销',
    agreementContent: '协议内容',
    all: '全部',
    allArea: '目标国家/ 地区',
    allComment: '全部评论',
    allImportSuccess: '导入完毕，全部导入成功',
    allServicesSimultaneously: '全部服务同时',
    allUser: '全部用户',
    allVehicleModel: '所有车型',
    alreadyOver: '已经到底了',
    ambientLightControl: '氛围灯控制',
    amount: '金额',
    android: '安卓',
    answer: '解答',
    answerOta1: 'OTA（Over the Air），即车辆通过蜂窝网络从云端下载最新固件软件，你可通过CFMOTO RIDE在线升级车辆，持续优化骑行体验',
    answerOta2: '若仪表有新版本可升级，将收到相关升级通知，若当前页面下方显示%s时，则代表车辆仪表无需升级',
    answerOta3: '可点击右上角的%s提前了解更多OTA操作说明',
    anyCar: '是否有车',
    appMessagePushCountLimit: '您已达到本月推送上限（2次/月），本次编辑内容可保存为草稿，是否保存？',
    appPush: 'APP消息推送',
    appRating: '评分机制管理',
    appType: '手机系统',
    appVersion: 'APP版本',
    applicableCountry: '适配国家',
    applicableCountryName: '适用国家',
    applyTime: '申请时间',
    applyUnbinding: '申请解绑',
    appointmentReleaseTime: '预约发布时间',
    approval: '同意',
    arrivalNumberDescription: '通知消息发送后，实际送达至设备终端的数量',
    arrivalNumberDescription0: '通知消息发送后，实际送达至设备终端的数量，5天之后的送达数量不被计算在内',
    arrivalNumberVolume: '送达数量',
    askAllowUserSpeakInCommunity: '确定解除当前用户的社区禁言限制吗',
    askApproveIt: '确定要审核通过吗',
    askDeleteCategory: '是否删除该分类',
    askDeleteInformactionCategory: '是否删除该资讯类别',
    askDeleteInformationContent: '是否删除该资讯内容',
    askDeleteKolUserAuthentication: '确定要删除该KOL用户认证吗',
    askDeleteOfficialAuth: '确定删除该账号的官方认证吗？',
    askDeleteQuestion: '是否删除该问题',
    askDeleteThisActivity: '确定要删除该活动吗',
    askDeleteThisBanner: '确定要删除该Banner吗',
    askDeleteThisComment: '确定要删除该条评论吗',
    askDeleteThisPost: '确定要删除该条帖子吗',
    askDeleteThisTopic: '确定要删除该话题吗',
    askDeleteVehicleType: '是否确认删除该车型',
    askDeleteVehicleTypeCategory: '是否删除该车型类别',
    askDeleteVehicleTypeDetails: '是否删除该车型详情',
    askDeleteVehicleTypeSeries: '是否删除该车型系列',
    askLogout: '确定退出系统么？',
    askNotApproveIt: '确定要审核不通过吗',
    askSaveSettings: '还未保存设置，是否保存',
    associatedPostNumber: '关联帖子数',
    associatedPosts: '关联帖子',
    associatedVehicle: '关联车辆',
    assoclatedContent: '关联内容',
    atmosphereCContent: '还未保存设置，是否保存？',
    atmosphereContent1Msg1: '功能开启后，手机打开蓝牙且APP保持运行，从远到近靠近车辆，车辆即可自动解锁上电',
    atmosphereContent1Msg2: '若未正常解锁上电，按车辆上电按钮也可解锁上电',
    atmosphereContent1Msg3: '靠近自动解锁在蓝牙断开前仅会触发一次',
    atmosphereContent2Msg1: '功能开启后，满足车辆熄火、车速为0且边撑落下三个条件后，车辆将在5秒后自动下电',
    atmosphereContent2Msg2: '在自动下电期间启动车辆、车速不为0或收起边撑都会取消自动下电',
    atmosphereContent3Msg1: '功能开启后，车辆为下电状态时，手机打开蓝牙且APP保持运行或携带实体钥匙，从远到近靠近车辆时会触发车辆灯光闪烁迎宾',
    atmosphereContent3Msg2: '为防止频繁触发导致车辆亏电，迎宾功能在30秒内连续触发2次后，需等30分钟后才会恢复',
    atmosphereContent4Msg1: '功能开启后，车辆下电后将自动打开远、近光灯10秒',
    atmosphereIntroduce1: '靠近自动解锁说明',
    atmosphereIntroduce2: '极简下电说明',
    atmosphereIntroduce3: '车辆迎宾说明',
    atmosphereIntroduce4: '伴你回家说明',
    atmosphereSetINfo: '新设置将在车辆上电后1-3分钟内生效，请确保车辆处于信号良好位置',
    auditStatus: '审核状态',
    authType: '认证类型',
    authenticatedName: '认证名称',
    avatar: '头像',
    backApply: '撤回申请',
    backApplySuccess: '撤回申请成功',
    backHome: '返回首页',
    bannerDisplayImages: 'banner展示图',
    bannerList: 'Banner列表',
    bannerManagement: 'Banner管理',
    bannerPictrure: 'Banner图',
    bannerSearch: 'Banner查询',
    bannerTitle: 'banner名称',
    baseService: '基础服务',
    baseServicePay: '基础服务付费',
    baseServiceResetTimeRule: '基础服务重置时间不能大于当前时间',
    batchImport: '批量导入',
    batchUser: '批量用户',
    beijingTime: '北京时间',
    belogCategory: '所属类别',
    belongCategory: '所属分类',
    bindDevice: '绑定设备',
    bindEmail: '绑定邮箱',
    bindVehicle: '绑定车辆',
    bindingStatus: '绑定状态',
    bindingText1: '1.远程信息处理服务',
    bindingText10: '1.1.2.在导航过程中提供路线规划，包括计算与车辆的距离和以寻找车辆为目的的步行导航。',
    bindingText11: '1.2.根据车辆状况向客户发送必要的通知。',
    bindingText12: '1.2.1.CFMOTO将向客户发送车辆保养通知(例如，根据客户驾驶的总里程、客户购买车辆的时间、车辆保养所需的驾驶时间或行驶距离等)。',
    bindingText13: '1.2.2.CFMOTO将根据车辆上报数据向客户发送车辆异常情况的通知：包括OEM的数据分析(取决于车型)，以便向客户提供服务和进行车辆的后续优化。',
    bindingText14: '1.3.如果客户反馈车辆发生严重事故的，协助分析事故原因。',
    bindingText15: '1.3.1.如果车辆发生严重事故，例如车辆在行驶过程中倾覆或侧翻，CFMOTO将根据客户的要求，协助客户澄清事故是由于车辆的缺陷还是其他情况造成的。客户应通过车辆销售协议中指定的当地经销商/销售合作伙伴向CFMOTO提交请求。',
    bindingText16: '1.3.2.在现有数据允许的情况下，CFMOTO将评估分析与事故原因相关的数据，并向客户提供相应的报告。',
    bindingText17: '1.4.协助客户在车辆遗失后取回车辆。',
    bindingText18: '1.4.1.如果车辆丢失，CFMOTO将根据客户的要求，在可用的情况下，向客户提供车辆的位置数据和其他有用的车辆状态数据(如上次激活的位置、当前车辆状态等)。',
    bindingText19: '1.4.2.客户应通过车辆销售协议中指定的当地经销商/销售合作伙伴向CFMOTO提交请求。',
    bindingText2: 'CFMOTO Powersports, Inc.(以下简称“CFMOTO”)为购买CFMOTO车辆的客户(以下简称“客户”)提供车辆远程信息处理服务。为提供该服务，CFMOTO将收集、使用车辆在相关时间段内记录的与车辆状态及客户驾驶行为相关的数据。主要涉及以下数据：',
    bindingText20: '1.5.报告售后问题。',
    bindingText21: '1.5.1.在车辆部件发生故障时，CFMOTO远程收集车辆发送的错误代码通知，并应客户要求直接向客户提供相关信息。',
    bindingText22: '1.5.2.客户应通过车辆销售协议中指定的当地经销商/销售合作伙伴向CFMOTO提交请求。',
    bindingText23: '2.服务的限制和排除',
    bindingText24: '2.1.需要明确指出的是，车辆的结构或其他技术的变化可能限制服务的提供，甚至使服务无法正常提供，因为远程信息处理服务取决于车辆数据的正确提供。',
    bindingText25: '2.2.如因任何第三方数据或电信网络的性能而无法正常提供该服务的，CFMOTO不承担任何责任。',
    bindingText26: '3.隐私',
    bindingText27: '在处理与CFMOTO车辆相关的个人数据时，CFMOTO将遵守客户住所地适用的数据保护法规。CFMOTO的隐私政策条款载于本CFMOTO RIDE App。本须知作为隐私政策的补充，与隐私政策保持一致，本须知未涉及的与数据处理相关的内容，客户可参考隐私政策。',
    bindingText28: '4.客户服务',
    bindingText29: '4.1.客户可自主将其与隐私相关的问题、评论或疑虑发送至CFMOTORIDEAPP@cfmotousa.com或致函：CFMOTO Powersports, Inc., 3555 Holly Lane North, Suite 30, Plymouth, MN 55447。客户也可致电(888)823-6686联系CFMOTO客户关系部。',
    bindingText3: '客户驾驶行为数据：包括加速、减速、车速、压弯、最后一次驾驶时间、最后一次驾驶里程。',
    bindingText30: '5.修订',
    bindingText31: '5.1.CFMOTO保留随时修订本须知的权利，但我们将于修订前在CFMOTO RIDE App上发布修订版本和/或修订通知。',
    bindingText4: '车辆状态数据：指车辆的实时状态，包括行驶模式、剩余燃油、即时燃油经济性、行驶里程、车辆实时档位、发动机转速、胎压、胎温、电池激活电压数据、冷却液温度、电子锁状态、智能设备软件版本、智能设备信号强度、仪表板当前设置。',
    bindingText5: '车辆报警数据：当车辆状态的某些数值超过预设值时发送报警数据，如发动机温度、超速、行驶时间过长、冷却液温度过高、车辆运动异常、胎压异常、振动、倾倒、碰撞等。',
    bindingText6: '车辆故障信息：指车辆内部各部件上报的故障代码。',
    bindingText7: '车辆位置数据：指车辆的具体地理位置。',
    bindingText8: '1.1.通过CFMOTO RIDE App为客户提供与车辆相关的服务。',
    bindingText9: '1.1.1.客户可以通过CFMOTO RIDE App远程管理车辆(包括查看车辆位置、设置车辆信息、功能、远程控制车辆状态等)。',
    bindingUser: '绑定用户',
    bothServices: '两项服务同时',
    bound: '已绑定',
    businessType: '业务类型',
    button: '按钮',
    callbackedApply: '您已于yyyy-MM-dd HH:mm:ss撤回账户删除申请',
    callbackedApplySyncTip: '账户删除申请已于yyyy-MM-dd HH:mm:ss提交，我们会自收到申请15天后彻底删除您的账户及相关数据，删除后您将无法使用CFMOTO RIDESYNC 服务。如您想取消申请，请在15天内及时通过网页或登录APP撤回账户删除申请',
    callbackedApplyTip: '账户删除申请已于yyyy-MM-dd HH:mm:ss提交，我们会自收到申请15天后彻底删除您的账户及相关数据，删除后您将无法使用CFMOTO RIDE 服务。如您想取消申请，请在15天内及时通过网页或登录APP撤回账户删除申请',
    canadaPrivacyPolicy: '加拿大隐私政策',
    canadaTelematicsPolicy: '加拿大远程信息服务处理协议',
    canadaUserPolicy: '加拿大用户协议',
    canadianAgreementText: '加拿大协议文本',
    cancel: '取消',
    cancellationAgreement: '注销协议',
    cancelled: '已注销',
    carOwner: '车主',
    carUserScore: '车主用户评分',
    cardPass: '身份验证通过！',
    cfmotoName: '春风动力',
    changeCodeValidate: '切换验证码验证',
    changeDescriptionType: '变更说明',
    changeDescriptionTypeSelectNo: '不涉及个人信息处理规制变更',
    changeDescriptionTypeSelectYes: '涉及个人信息处理规制变更',
    changeEmail: '修改邮箱',
    changeEmailInfo: '切换邮箱信息',
    changeFail: '状态修改失败',
    changeOne: '看不清，换一张',
    changePassValidate: '切换密码验证',
    changePasswordFailed: '密码修改失败',
    changePasswordSuccessful: '密码修改成功',
    changePhoneInfo: '切换手机号信息',
    changeStore: '修改门店',
    changeSuccess: '状态修改成功',
    channelType: '反馈渠道',
    characterLimitExceeded: '超过字数限制',
    checkConfigurationTwo: '中文或英语%s未配置完整，请检查',
    checkCopyWriting: '中文或英语弹窗文案未填写，请检查',
    checkEmpty: '%s为空，请检查',
    checkEmptyEnglish: '英语未填写完整，请检查',
    checkTriggerType: '存在触发机制条件未填写，请检查',
    checkUpdate: '检查更新',
    cityFilter: '城市筛选',
    clickImmediateFeedback: '点击立即反馈',
    clickNumber: '点击次数',
    clickNumberDescription: '通知消息成功展示后，实际被用户点击的数量',
    clickNumberVolume: '点击数量',
    clickToFeedback: '点击去反馈',
    clicks: '点击量',
    closeNum: '关闭',
    closeTask: '任务终止',
    code: '验证码',
    colorPicture: '色块图片',
    comment: '评论',
    commentContent: '评论内容',
    commentList: '评论列表',
    commentNumber: '评论数',
    commentTime: '评论时间',
    communication: '沟通中',
    community: '社区',
    communityManagement: '社区管理',
    communityRule: '社区规则配置',
    completePuzzle: '请完成拼图',
    completed: '已完成',
    condition: '条件',
    configureLanguage: '配置语种',
    configurePicture: '配置图片',
    confirm: '确认',
    confirmDeletePictures: '确认删除该图片',
    confirmRedeem: '确定兑换',
    confirmReviewNoPass: '确定审核不通过',
    confirmReviewPass: '确定审核通过',
    consultDealer: '请咨询当地经销商',
    contact: '您的账户删除申请被拒绝，如有疑问请联系it@cfmoto.com咨询处理',
    contactMail: '联系邮箱',
    contactMethod: '联系方式',
    contactUs: '联系我们',
    content: '内容',
    contentType: '内容类型',
    copyFail: '复制失败',
    copyLink: '复制链接',
    copySuccess: '复制成功',
    copyWriting: '弹窗文案',
    country: '所在国家',
    countryCode: '区号',
    countryName: '国家',
    countryNumber: '国家编号',
    countryRegion: '国家/地区',
    create: '新增',
    createBy: '创建人',
    createStore: '创建门店',
    createTime: '创建时间',
    cs_CZ: '捷克语',
    currency: '币种',
    currentConfig: '当前配置',
    currentCountryStoreTotal: '当前国家门店总数',
    currentRedemptionRatio: '当前兑换比例',
    currentTime: '当前时间',
    customPage: '自定义页面',
    customSettings: '自定义列',
    dashcamHelp: '行车记录仪帮助',
    dataDeletExplain: '数据删除说明',
    dataDelete: '数据删除',
    dataDeleteApply: '数据删除申请',
    dataFormatError: '数据格式错误',
    dataPermissionScope: '数据权限范围',
    dataType: '数据类型',
    dayOne: '天一次',
    days: '天',
    daysAgo: '%s天前',
    de_DE: '德语',
    dealDate: '处理时间',
    dealerOperationList: '经销商操作列表',
    dealerOperationQuery: '经销商操作查询',
    dealerOperationRecord: '经销商操作记录',
    dealerStore: '经销商门店',
    dealerStoreImportTempateName: '经销商门店导入模板',
    dealerStoreQuery: '经销商门店查询',
    dealers: '所属进口商',
    default: '默认',
    defaultMap: '默认地图',
    delete: '删除',
    deleteAccountSYNCStep: '您可以执行以下步骤来要求我们删除您的CFMOTO RIDESYNC账户',
    deleteAccountStep: '您可以执行以下步骤来要求我们删除您的CFMOTO RIDE账户',
    deleteDataSYNCStep: '您可以执行以下步骤来要求我们删除您的CFMOTO RIDESYNC数据',
    deleteDataStep: '您可以执行以下步骤来要求我们删除您的CFMOTO RIDE数据',
    deleteFail: '删除失败',
    deleteFinish: '删除完毕',
    deleteKolUserAuthentication: '删除KOL用户认证',
    deleteStore: '删除门店',
    deleteSuccess: '删除成功',
    deleteTip: '确认删除此信息？删除后，信息将无法恢复',
    deleteVersionWarn: '是否删除该版本记录',
    deleteVideo: '是否删除此条视频',
    detailAddress: '详细地址',
    details: '详情',
    determine: '确定',
    deviceCodeGet: '设备码的获取：',
    deviceContent:
      '电子围栏接收器（简称：钥匙）设备码为一串10位的编码，银色PVC不干胶贴纸的标签上印刷有设备码，二维码及CE标识。标签共有三张，一张已贴于车辆本体（需掀起坐垫查看）；另外两张放置于随车配件袋内。（建议用户可将标签贴于随车使用说明书中或遥控器上）',
    deviceNo: '关联设备号',
    deviceNumber: '设备号',
    deviceTitle: '设备码查看',
    digitalKey: '数字钥匙',
    digitalKeyDesc: '无需携带物理钥匙，支持通过APP蓝牙连接后解锁车辆（部分车型支持）',
    directRelease: '直接发布',
    disagree: '不同意',
    displayNumberDescription: '通知消息送达后，实际在设备终端成功展示的数量',
    displayNumberVolume: '展示数量',
    displayOrder: '展示顺序',
    displayPicture: '展示图',
    donwloadTemplateDescription: '请先下载模板，填写（内容仅支持文本格式）完毕后上传文件；文件大小限制在2M以内，如提交失败，请适当减少内容。',
    download: '下载',
    downloadFailFile: '下载失败文件',
    downloadSuccessful: '下载成功',
    downloadTemplate: '下载模板',
    downloading: '下载中...',
    ebookChoice: '语言选择',
    ebookEmpty: '暂无说明书',
    ebookPlaceholder: '请输入车架号进行查询',
    ebookSwitch: '语言切换',
    ebookTitle: '电子说明书',
    edit: '编辑',
    editAccountDeletExplain: '编辑账户删除说明',
    editActivity: '编辑活动',
    editAppRating: '编辑评分机制',
    editBanner: '编辑Banner',
    editCanadaPrivacyPolicy: '编辑加拿大隐私政策',
    editCanadaTelematicsPolicy: '编辑加拿大远程服务处理协议',
    editCanadaUserPolicy: '编辑加拿大用户协议',
    editDashcamHelp: '编辑行车记录仪帮助',
    editDataDeletExplain: '编辑数据删除说明',
    editExhibitionCategory: '编辑展厅分类',
    editExhibitionSeries: '编辑系列',
    editFunctionIntro: '编辑功能介绍',
    editHelpConfiguration: '编辑帮助说明配置',
    editInformation: '编辑资讯',
    editInformationCategory: '编辑资讯类别',
    editInformationContent: '编辑资讯内容',
    editKolUserAuthentication: '编辑KOL用户认证',
    editModelSeries: '编辑车型系列',
    editPicture: '编辑图片',
    editPushConfiguration: '编辑推送配置',
    editRemark: '编辑备注',
    editServiceIntroduce: '编辑服务介绍',
    editShowroomModel: '编辑展厅车型',
    editSuccess: '编辑成功',
    editTime: '编辑时间',
    editUnbindingCommitment: '编辑解绑申请承诺书',
    editUser: '编辑用户',
    editVehicleModel: '编辑车型',
    editVehicleModelCategory: '编辑车型类别',
    effecting: '待生效',
    effectiveTime: '生效日期',
    electricVehicle: '电动车',
    email: '电子邮箱',
    emailAdress: '邮箱地址',
    emailAdressTip: '说明：此邮箱地址用于顾客邮件联系，请确保邮箱地址无误',
    emailBindingFailed: '绑定邮箱失败',
    emailContent: '邮件内容',
    emailImportTemplate: '电子邮箱导入模板',
    emailImportTemplateToDownLoad: '可批量导入电子邮箱地址，点击下载',
    emailList: '邮件列表',
    emailManage: '邮件管理',
    emailMass: '邮件群发',
    emailSearch: '邮件查询',
    emailSendTip1: '注意：请务必在你的邮件的末尾添加下方蓝色字体的说明。如果您的邮件文本不是英语，请将它翻译成您所使用的语言再添加。',
    emailSendTip2: '如果您想取消订阅此类邮件，请进入CFMOTO RIDE App，点击[Me]页面，进入[设置]，进入[消息通知]关闭[接收电子邮件营销]功能。',
    emailSendTip3: '*没有添加说明的邮件将无法审核通过。',
    emailText: '邮件',
    emailTitle: '邮件标题',
    en_US: '英语',
    enableStatus: '启用状态',
    enabled: '启用',
    endTime: '结束时间',
    endTimeLargeStartTime: '结束时间必须大于开始时间',
    enterAnswer: '请输入解答',
    enterCategory: '请输入分类',
    enterCodeToSafeAccount: '为保障您的账户安全，请确认您需要删除的账户信息，并输入密码或验证码进行身份验证',
    enterCodeToSafeData: '为保障您的数据安全，请确认您的账户信息，并输入密码或验证码进行身份验证',
    enterIntroduceText: '请输入介绍文本',
    enterLink: '请输入链接地址',
    enterPopupTitle: '请输入弹窗标题',
    enterQueryConditionLookData: '输入查询条件后可查看数据',
    enterQuestion: '请输入问题',
    enterQuestionAndAnswer: '中文与英文问题解答必须填写',
    enterSureUrl: '请输入正确的网址(网址中一定以http,https开头)',
    enterTypeOfLanguage: '中文与英文分类必须填写',
    enterUnbindingCommitment: '请输入解绑申请承诺书',
    entrance: '进口商账号管理',
    errorLatAndLon: '经纬度格式错误，请检查',
    errorLocation: '地点报错',
    es_ES: '西班牙语',
    estimatedTime: '预计耗时',
    everySet: '每设定',
    examineResultMessage: '我们将尽快核实申请材料，请及时关注通知栏或APP消息中心。',
    example: '例',
    exchange: '去兑换',
    exchangeDescription1: '尊敬的CFMOTO车主，您的车辆绑定成功，并获得一年智能服务免费体验期。\n请选择您要开通的服务：\n-车辆数据基础服务\n-MotoPlay\n请阅读并同意以下条款\n查看《智能服务协议》\n【确认】\t',
    exchangeDescription2: '请查阅电子版说明书获取完整车辆信息。您还可享受CFMOTO RIDE智能服务的1年免费体验期，有效期自首次绑定之日起计算。\n[ 关闭 ] [ 我已知晓 ]',
    exchangeDescription3:
      '您当前有 XXX km可用里程，置换后可继续享受CFMOTO RIDE智能服务。若未及时置换，解绑账户后，里程数据将保留30天，逾期未置换将自动清零且无法恢复。\n请确认是否立即置换？\n[是] [否]\n \n*置换后的里程权益将绑定车辆，由下一任车主继续使用。',
    exchangeDescription4: '您当前有 XXX km可用里程，置换后可继续享受CFMOTO RIDE智能服务。\n请确认是否立即置换？\n[是]  [否]',
    exchangeDescription5: '智能服务提醒尊敬的CFMOTO车主: CFMOTO智能服务免费体验剩余XXX天。如您开通智能服务，将于24小时内激活，请注意查收。[确认]',
    exchangeDescription6: '享受更优质的路线指引，MotoPlay提供由谷歌地图支持的投屏和导航服务',
    exchangeRecords: '兑换记录',
    exchangeServiceTime: '有里程可兑换服务时长',
    exchangeSuccess: '兑换成功',
    exhibition: '展厅管理',
    exhibitionCategory: '展厅分类',
    exhibitionCategoryList: '展厅分类列表',
    exhibitionCategorySearch: '展厅分类查询',
    exhibitionSeries: '展厅系列',
    exhibitionSeriesList: '展厅系列列表',
    exhibitionSeriesSearch: '展厅系列查询',
    exportContent: '导出内容',
    exportExcel: '导出EXCEL',
    exportLengthExceedOfMonth: '导出长度不超过%s个月',
    externalLink: '外部链接',
    failed: '失败',
    failedToPreview: '审核不通过',
    feedBackResut: '反馈结果',
    feedBackTime: '反馈时间',
    feedBackVechle: '反馈车辆',
    feedbackAppQuestion: '详细描述发生时间、APP版本、手机机型、操作路径及问题说明，有助于快速定位并排查问题哦~',
    feedbackDetails: '反馈详情',
    feedbackGuideDesc: '如需了解更多信息，请通过下方反馈渠道联系我们',
    feedbackLabelFileList: '请上传图片',
    feedbackMapQuestion: '如发现APP地图内地址或街道显示信息与实际不符时，请提供你所在地区、当前问题地址（或街道）信息、实际道路信息。问题描述越详细，更有利于我们排查并准确更新地图数据。',
    feedbackMessageSubmitError: '反馈失败',
    feedbackOtherQuestion: '请描述发生时间、操作路径及问题说明',
    feedbackReceived: '反馈已收到',
    feedbackRecord: '反馈记录',
    feedbackRulesFileListMaxSize: '上传文件过大',
    feedbackRulesFileListOverType: '不支持的格式',
    feedbackSubmitTip: '如有任何疑问或意见，您还可以通过WhatsApp(+52 18115286003) 或电子邮件（servicioalclient@cfmoto.com.mx）直接联系CFMOTO墨西哥客户服务中心',
    feedbackSuggest: '欢迎提出宝贵建议，我们会认真考虑您的想法',
    feedbackSupplement: '请补充问题说明',
    feedbackText: '反馈',
    feedbackType: '反馈类型（单选）',
    feedbackVehicleQuestion: '详细描述当前车辆情况，有助于快速定位并排查问题哦~',
    female: '女',
    fileCountExceed: '文件个数超出限制',
    fileSizeExceed: '文件大小超出限制',
    fileUploadingPleaceWait: '文件上传中，请稍等',
    finalOperator: '最终操作人',
    firstBindDate: '车辆首绑时间',
    firstMenu: '一级菜单',
    forcedUpgrade: '强制升级',
    forgetPassword: '忘记密码',
    fourCarOfNumber: '四轮车用户次数',
    fourWheel: '四轮摩托车',
    fourWheelConfig: '成人四轮车辆配置',
    fourWheeler: '四轮车',
    fourWheelerMostClicks: '四轮最多点击车型',
    fourWheelowner: '成人四轮车主',
    fr_FR: '法语',
    frankfurt: '法兰克福',
    freeLastDayBasedata: '基础服务免费时长',
    freeLastDayMotoplay: 'MotoPlay免费时长',
    friday: '周五',
    fuctionIntro: '功能介绍',
    fullscreen: '全屏',
    funServiceIntro: '功能服务介绍',
    function: '功能',
    functionConfiguration: '功能配置',
    functionConfigureTip: '功能仅针对所配置进口商名下的车辆或所属国家/地区的用户生效',
    functionDescription: '功能仅针对所配置进口商名下的车辆生效',
    functionDetail: '配置(根据车辆所属进口商)',
    functionIntroduce: '功能说明',
    functionSetting: '地图越野功能配置',
    functionalOverview: '功能概览',
    galleryEntrance: '图库入口',
    galleryEntranceUploadRules: '格式要求：jpg/jpeg/png，建议比例4:3，大小不超过5MB',
    gender: '性别',
    generalAgreementText: '通用协议文本',
    generalAlarm: '普通报警',
    geofence: '电子围栏',
    getCarPosition: '及时获取车辆定位',
    getCode: '发送验证码',
    getExchangeRecordsError: '获取兑换记录失败',
    goCustomPage: '跳转至自定义页面',
    goOffline: '下线',
    goOnline: '上线',
    goUrlLink: '跳转至URL链接',
    groupTrail: '组队越野',
    groupTrailConfig: '组队越野功能配置',
    guest: '无车',
    haveTwo: '两种都有',
    havedWrite: '已填写',
    havedWriteAll: '中所有内容均已填写',
    havedWriteAllOrEmpty: '中所有内容均已填写或均为空',
    helpAndFeedback: '帮助与反馈',
    helpCenter: '帮助中心',
    helpConfiguration: '帮助说明配置',
    helpMessageHistoryDelete: '是否删除全部历史搜索记录？',
    helpful: '有帮助',
    hint: '提示',
    historyDelete: '是否删除全部历史搜索记录',
    home: '首页',
    homePage: '个人主页',
    hour: '小时',
    hoursAgo: '%s小时前',
    iWantEnableStoreUserQuery: '我要开通门店查询用户查询',
    iWantToPostStatistics: '我要发帖统计',
    identification: '身份证明',
    identificationText: '标识',
    imageSizeExceed: '请上传宽高为%s的图片',
    imageUploadFailed: '图片上传失败',
    immediateRelease: '立即发布',
    immediateSend: '立即发送',
    imporFailedOfTableHeader: '导入失败，文件表头不匹配',
    import: '导入',
    importDetails: '问题详情',
    importExcel: '导入EXCEL',
    importFail: '导入失败',
    importStatus: '导入状态',
    importSuccessful: '导入成功',
    importTemplate: '导入模板下载',
    importer: '进口商',
    importerAccountOperationRecord: '进口商账号操作及登录记录',
    importerAvatar: '进口商头像',
    importerDisplayName: '进口商展示名称',
    importerEnquiry: '进口商查询',
    importerManagement: '进口商管理',
    importerOperationRecords: '进口商操作记录',
    importing: '导入中',
    inProcess: '对策中',
    inProgress: '进行中',
    individualCenter: '个人中心',
    informationCategory: '资讯类别',
    informationCategoryList: '资讯类别列表',
    informationCategoryQuery: '资讯类别查询',
    informationContent: '资讯内容',
    informationContentList: '资讯内容列表',
    informationCotnentQuery: '资讯内容查询',
    informationCover: '资讯封面',
    informationDetails: '资讯详情',
    informationImage: '封面图片',
    informationManagement: '资讯管理',
    informationTitle: '资讯标题',
    informer: '举报人',
    informerId: '举报人ID',
    initialPassword: '初始密码',
    inputAgreementContent: '请输入协议内容',
    inputCannotExceed20000: '输入不能超过20000字',
    inputErrorEmoji: '请勿输入表情符号',
    installDeviceYouCan: '安装此设备，你可以',
    installVehicleModelAdd: '新增加装车型说明',
    installVehicleModelDescription: '加装车型说明',
    installVehicleModelEdit: '编辑加装车型说明',
    instrumentLastedVersion: '仪表已是最新版本',
    instrumentupgrade: '仪表升级',
    inteligentServiceReminder: '智能服务提醒',
    intelligentInternetServiceIntroduction: '智能网联功能介绍',
    intelligentServiceAgreement: '智能服务协议',
    intelligentServices: '智能服务（车辆详情、骑行数据、OTA）',
    introText: '介绍文本',
    introduction: '简介',
    invalidVercode: '无效的验证码',
    invoicePreview: '发票预览',
    invoicing: '开票中',
    invoicingFailed: '开票失败',
    invoicingSucceeded: '开票成功',
    iovNotice1: '以上功能均基于车辆联网设备（T-Box）实现，请咨询当地经销商购买安装',
    iovNotice2: '以上功能根据各车型配置、所在地区不同有所区别，详情请咨询当地经销商',
    iovNotice3: '请提前保存并记录设备编号，绑定设备时需填写。完成绑定和安装后，即可体验更多功能',
    isHelpful: '这是否有帮助？',
    isStop: '是否停止',
    isSupportedChildOwnerOffMapDown: '非成人车主是否支持离线地图下载',
    isSupportedNoOwnerOffMapDown: '非车主是否支持离线地图下载',
    isSupportedOffMapDown: '是否支持离线地图下载',
    it_IT: '意大利语',
    iterativeVehicleFunctions: '车辆主要零部件可以通过远程在线升级，持续迭代车辆功能',
    jumpSettings: '跳转设置',
    jumpTarget: '跳转目标',
    jumpToWeb: '跳转官网链接',
    jumpUrl: '跳转链接',
    justNow: '刚刚',
    keySharing: '数字钥匙 & 钥匙分享',
    kolUser: 'KOL用户',
    kolUserList: 'KOL用户列表',
    kolUserManagement: 'KOL用户管理',
    kolUserQuery: 'KOL用户查询',
    language: '语言',
    language1: '所属语言',
    languages: '所属语种',
    lastLoginTime: '上次登录时间',
    lastModifiedBy: '最后修改人',
    lastUpdateTime: '最后一次更新时间',
    latitude: '纬度',
    launchActivity: '发布活动',
    likeNumber: '点赞数',
    linkAddress: '链接地址',
    linkUrlDescription: '网址中一定以http,https开头',
    linkedOrder: '关联订单',
    listDisplayImages: '列表展示图',
    listOfImporters: '进口商列表',
    listOfQuestion: '问题列表',
    listShowStoreCoverPic: '列表展示门店封面图',
    loadMore: '加载更多',
    loadSuccess: '加载完成',
    loading: '加载中',
    locationFail: '定位失败',
    log: '日志',
    login: '登录',
    loginCountry: '登录国家/地区',
    loginSuccessfully: '登录成功',
    logout: '退出登录',
    longitude: '经度',
    loosing: '正在刷新数据中...',
    lowCompatibleVersion: '最低兼容版本',
    mail: '邮箱',
    male: '男',
    manualReviewStatus: '人工审核状态',
    mapManage: '地图管理',
    marketDataOfdealerStores: '经销商门店数据大盘',
    masteringCyclingData: '掌握骑行数据',
    maximum: '最高',
    maximumBannerCountTip: 'Banner最多同时在线%s条，请先下线至少一条其他banner',
    maximumMileage: '最大可兑换里程',
    maximumValue: '最高值',
    menuFunctionName: '菜单功能名称',
    menuIcon: '菜单图标',
    messagePush: '消息推送',
    messagePushDeleteAsk: '是否确认删除该条推送内容',
    messagePushDownloadTemplate: '请先下载模板，在模板文件中填写完毕后上传文件; 文件大小限制在2M以内，如提交失败，请适当减少内容。',
    messageWithdrawAsk: '是否撤回该条推送',
    middle: '中',
    min: '分钟',
    minAgo: '%s分钟前',
    minimum: '最低',
    minimumValue: '最低值',
    modelDetail: '车型详情',
    modifyFail: '修改失败',
    modifyPassword: '修改密码',
    modifySuccess: '修改成功',
    monday: '周一',
    more4pic1video: '最多4张图片/1个视频',
    moreDetailsConsultDealerStore: '更多详情可咨询您的经销商门店',
    morning: '上午',
    motoPlay: 'MotoPlay（谷歌导航与投屏服务）',
    motoPlayAgreement: 'MotoPlay协议状态',
    motoplatNavigationScreen: 'MotoPlay导航投屏',
    motoplayServicePay: 'MotoPlay付费',
    motoplayServiceResetTimeRule: 'MotoPlay重置时间不能大于当前时间',
    motorcycle: '两轮摩托车',
    moveDown: '下移',
    moveLongPressMap: '移动或长按地图选择地点',
    moveMapSelectPoint: '移动地图选点',
    moveTo: '移至',
    moveToBottom: '移至底部',
    moveToTop: '移至顶部',
    moveToTopStatus: '置顶状态',
    moveTop: '置顶',
    moveUp: '上移',
    multimedia: '多媒体',
    mustInteger: '必须为正整数',
    mute1Day: '禁言1天',
    mute2Days: '禁言2天',
    mute30Days: '禁言30天',
    mute3Days: '禁言3天',
    mute7Days: '禁言7天',
    muting: '禁言中',
    nameOfImporter: '进口商名称',
    navigation: '地图导航',
    nearLoginTime: '最近登录时间',
    needPopup: '需要弹窗',
    negativeNum: '差评',
    networkException: '网络异常',
    newAddFail: '新增失败',
    newAddSuccess: '新增成功',
    newBanner: '新增Banner',
    newCancellationAgreement: '新增注销协议',
    newEmail: '新邮箱',
    newEmailEqualsValidate: '新邮箱不能与原邮箱相同',
    newFunctionIntro: '新增功能介绍',
    newMenuFunction: '新增菜单功能',
    newModelSeries: '新增车型系列',
    newPassword: '新密码',
    newPasswordNotEqual: '新密码两次输入不一致，请重新输入',
    newQuestionType: '新增问题分类',
    newStoreNumber: '新增门店数',
    newTopic: '新增话题',
    newUnbindingCommitment: '新增解绑申请承诺书',
    nextStep: '下一步',
    nickName: '昵称',
    no: '否',
    noContent: '暂无相关内容',
    noContent2: '建议更换关键词或',
    noData: '暂无数据',
    noExchangeRecord: '还没有兑换记录',
    noFeedbackRecord: '当前暂无反馈记录哦~',
    noJump: '无跳转',
    noLog: '暂无日志',
    noMores: '没有更多了',
    noNeedPopup: '不需弹窗',
    noOkToFeedback: '未解决，我要反馈',
    noOwnerScore: '非车主用户评分',
    noPass: '不通过',
    noSendPeople: '没有发件人',
    noSortingPermission: '您暂无排序权限',
    noSupportMapDown: '不支持离线地图下载',
    noThisPermission: '无此操作权限',
    noUserSelected: '未选择用户，不可提交',
    nofiledSeviceContent: '未填写服务介绍内容',
    nonOwner: '非车主',
    nonVehicleOwnerCharged: '非车主试用后收费',
    none: '无',
    normal: '正常',
    notAllowImageAndVideo: '选择图片时不能选择视频',
    notAllowed: '不允许',
    notBeLessOrEqual: '不得小于或等于',
    notDeleted: '未注销',
    notDistributedYet: '暂未下发',
    notEnabled: '未启用',
    notHelpful: '无帮助',
    notLessThan: '不得小于',
    notRecommended: '不推荐',
    notReleasedYet: '暂不发布',
    notStarted: '未开始',
    'notSupportT-Box': '抱歉，您的车辆不支持后加装T-Box设备',
    notTop: '不置顶',
    notice: '注意',
    noticeText1: '尊敬的CFMOTO用户，',
    noticeText2:
      '您好！我们衷心感谢您一直以来对CFMOTO的支持与信任。为了不断提升您的服务体验，我们持续致力于服务品质的提升和创新改进。在此背景下，我们进行了业务调整，并特此通知您，自08/10/2024起，我们将在美国地区停止CFMOTO RIDE App（下称“本App”）的服务。为了保障您的服务体验不受影响，我们推出了全新的CFMOTO RIDESYNC App，期待您通过这款新应用继续享受我们的新服务。',
    noticeText3: '重要事项提示：',
    noticeText4: '1. 从今日起，本App将仅支持美国地区已绑定的CFMOTO车辆继续使用，而不再支持新的车辆绑定，若您需要绑定新车辆，请下载并使用CFMOTO RIDESYNC App。',
    noticeText5:
      '2. 我们强烈建议您在08/10/2024之前下载并使用CFMOTO RIDESYNC App，以便您能够无缝衔接地继续使用我们的服务。我们为您提供了便捷的数据迁移服务，您可以选择将本App中保留的全部数据迁移至CFMOTO RIDESYNC App以确保您的个人资料、车辆信息、服务使用记录得到完整保留，我们将在迁移过程中确保您的数据安全和隐私。如您想使用CFMOTO RIDESYNC App但选择不迁移数据的，您可以在CFMOTO RIDESYNC App重新注册以使用新服务。点击下方按钮了解如何下载并使用CFMOTO RIDESYNC App。',
    noticeText6: '3. 提醒您注意，08/10/2024后，您将无法再使用本App在美国地区的相关服务，同时，我们会依据相关法律法规要求删除您在使用本App过程中产生的全部个人数据。',
    noticeText7:
      '我们深知这一变动可能会为您带来短暂的不便，但我们相信，通过这次服务升级，您将获得更加丰富和满意的用户体验。在此过程中，如果您遇到任何问题或有任何疑问，我们将随时为您提供帮助。感谢您的理解与合作，我们期待在CFMOTO RIDESYNC App中继续为您服务。',
    noticeText8: '祝您生活愉快！',
    notzero: '版本号不可都为0',
    obtainVerificationCode: '获取验证码',
    officiaAndKolList: '官方/KOL列表',
    officialAccount: '官方账号',
    officialAccountAuth: '官方账号认证',
    officialIrKOLSearch: '官方/KOL查询',
    officialKolAuth: '官方/KOL认证',
    offline: '离线',
    offlineAlready: '已下线',
    offlineTime: '下线时间',
    offlineTimeMustBeGreaterThan: '下线时间必须大于',
    ok: '好的',
    oldPassword: '旧密码',
    onLineAlready: '已上线',
    oneMonths: '一个月',
    oneYear: '一年',
    online: '在线',
    onlyFourWheel: '只经营四轮',
    onlyTwoWheel: '只经营两轮',
    openEveryCount: '每次打开',
    openEveryDay: '每天打开',
    openProductType: '开放产品类型',
    operationRecord: '操作记录',
    operationTime: '操作时间',
    operations: '操作行为',
    operator: '操作人',
    operattor: '操作人员',
    opreate: '运营管理',
    opreateFunSet: '运营功能配置',
    opreateFunSetAdvert: '启动广告页',
    opreateFunSetAdvertAdd: '新增启动广告页',
    opreateFunSetAdvertEdit: '编辑启动广告页',
    opreateFunSetAdvertView: '查看启动广告页',
    optionalUpgrade: '非强制升级',
    orderFeedBackNum: '订单反馈次数',
    orderList: '订单列表',
    orderMange: '订单管理',
    orderNum: '订单编号',
    orderQuestion: '详细描述问题发生时间、具体现象，并上传错误截图，支付问题请同步上传扣款记录',
    originalEmail: '原邮箱',
    otaUpgradeVehicle: 'OTA升级车辆',
    otaUpgradeVehicleDesc: '车辆主要零部件可以通过远程升级，持续迭代车辆性能',
    other: '其他',
    over: '已结束',
    owner: '有车',
    ownerIdHomepageImage: '身份证、驾驶证或护照等包含个人身份信息的证件主页',
    parameterConfiguration: '参数配置',
    partialImportFailed: '部分导入失败',
    pass: '通过',
    passValidateDeleteAccount: '身份验证通过！点击底部提交申请按钮即可申请删除账户',
    password: '密码',
    passwordRuleText: '8-20字符，必须包含大小写英文字母、数字、特殊字符',
    passwordRules: '密码规则',
    paySetting: '地图收费管理',
    payStrategy: '支付策略',
    paymentLastDayBasedata: '基础服务付费时长',
    paymentLastDayMotoplay: 'MotoPlay付费时长',
    peleaseEnterProvince: '请输入省/州',
    pendSend: '待发送',
    pending: '待处理',
    pendingSubmit: '待提交',
    permanentMuting: '永久禁言',
    phoneModel: '机型',
    phoneNum: '手机号码',
    phoneNumber: '联系电话',
    phoneOrEmail: '手机号/邮箱',
    phoneOrEmailImportTemplate: '手机号/电子邮箱导入模板',
    phoneOrEmailNotRegistered: '该手机号或者邮箱未注册',
    phoneOrEmailOrUserId: '手机号/邮箱/用户ID',
    picture: '图片',
    pl_PL: '波兰语',
    pleaseAddImage: '请添加图片文件',
    pleaseAddVideoFile: '请添加视频文件',
    pleaseEnter: '请输入',
    pleaseEnterAccountInfo: '请输入账号信息',
    pleaseEnterAmount: '请输入金额',
    pleaseEnterCity: '请输入城市',
    pleaseEnterEmail: '请输入联系邮箱',
    pleaseEnterEmailAdress: '请输入邮箱地址',
    pleaseEnterIntro: '请输入简介',
    pleaseEnterLatAndLong: '请输入经纬度',
    pleaseEnterNewPassword: '请输入新密码',
    pleaseEnterPassword: '请输入密码',
    pleaseEnterPhone: '请输入联系电话',
    pleaseEnterQuestionDescription: '请输入问题描述',
    pleaseEnterRealname: '请输入真实姓名',
    pleaseEnterRemark: '请输入备注',
    pleaseEnterServePhone: '请输入服务电话',
    pleaseEnterStoreAddressDetail: '请输入详细地址',
    pleaseEnterStoreIntroduce: '请输入门店介绍',
    pleaseEnterStoreName: '请输入门店名称',
    pleaseEnterStoreRemarkName: '请输入门店备注名称',
    pleaseEnterTitle: '请输入标题',
    pleaseEnterUsername: '请输入用户名',
    pleaseEnterVercode: '请输入验证码',
    pleaseEnterVersion: '请输入版本号',
    pleaseEnterVersionIntroduction: '请输入版本介绍',
    pleaseEnterVideoDetail: '请输入视频详情',
    pleaseEnterVin: '请输入车架号',
    pleaseInputWord: '请输入关键词',
    pleaseLoginFirst: '请登录后使用',
    pleaseRepeatNewPassword: '请重复新密码',
    pleaseSelect: '请选择',
    pleaseSelectAuthAccount: '请选择认证账号',
    pleaseSelectBusinessHours: '请选择营业时间',
    pleaseSelectCity: '请选择城市',
    pleaseSelectCountry: '请选择国家',
    pleaseSelectCurrency: '请选择币种',
    pleaseSelectMatchingMultimediaContent: '请选择匹配的多媒体内容',
    pleaseSelectPayChannel: '请选择支付渠道',
    pleaseSelectProblemWhere: '请选择问题发生的场景',
    pleaseSelectProducType: '请选择产品类型',
    pleaseSelectProvince: '请选择省/州',
    pleaseSelectQueType: '请选择问题类型',
    pleaseSelectReportReason: '请选择举报原因',
    pleaseSelectService: '请先选择服务',
    pleaseSelectStatus: '请选择状态',
    pleaseSelectStoreType: '请选择门店类型',
    pleaseSelectTimedSendTime: '请选择发送时间',
    pleaseSelectUserTheList: '请在列表中选择用户',
    pleaseSelectVehicle: '请选择车辆',
    pleaseSelectVehicleConfig: '请选择车辆配置',
    pleaseSelectlinkedOrder: '请选择关联订单',
    pleaseSelectupgradeType: '请选择升级方式',
    pleaseSureType2: '请确保',
    pleaseUpload: '请上传',
    pleaseUploadPicVideo: '请上传图片/视频',
    pleaseUserTimeFill: '请根据终端用户时间填写',
    popUpFrequencyType: '弹窗形式',
    popUpFrequencyValue: '弹窗频次',
    popUpFrequencyValueValid: '请选择频次天数',
    popUpReminder: '是否弹窗提醒',
    popupArea: '弹窗范围',
    popupCreate: '新增弹窗',
    popupDayOne: '每设定天数一次',
    popupEdit: '编辑弹窗',
    popupFrequency: '弹窗频率',
    popupManagement: '弹窗管理',
    popupOne: '只弹一次',
    popupPosition: '弹窗位置',
    popupStatus: '弹窗状态',
    popupTarget: '弹窗目标',
    popupTime: '弹窗时间',
    popupTitle: '弹窗标题',
    positiveNum: '好评',
    postComment: '帖子评论',
    postContent: '帖子内容',
    postId: '帖子ID ',
    postList: '帖子列表',
    postManagement: '帖子管理',
    postSearch: '帖子查询',
    posts: '帖子',
    precautionText1: '您好！鉴于您已了解到我们将在08/10/2024起在美国地区停止CFMOTO RIDE App（下称“本App”）的服务，为了帮助您应对这一变化，请您关注并确认以下重要事项：',
    precautionText2: '1. 自今日起，您将无法通过本App绑定新的车辆以享受相关车辆服务。',
    precautionText3: '2. 为确保您能够顺利过渡到新服务，我们在本App的车辆页面顶部提供了一个入口，您可以随时通过该入口了解如何下载并使用CFMOTO RIDESYNC App。',
    precautionText4: '3. 请注意，一旦服务停止生效，您将无法再使用本App在美国地区的任何服务。同时，根据相关法律法规的要求，我们将删除您在使用本App过程中产生的所有个人数据。这意味着，在服务停止后，我们将无法响应您对数据的任何请求。',
    precautionText5:
      '我们深知这一变动可能会给您带来不便，但我们承诺将持续保护您的数据安全和隐私。我们鼓励您提前采取行动，及时下载并开始使用CFMOTO RIDESYNC App，以便继续享受CFMOTO提供的优质服务。如果您在此过程中有任何疑问或需要帮助，请随时联系我们。我们期待在CFMOTO RIDESYNC App中继续为您服务。',
    privacyContent: '隐私政策内容详情',
    privacyPolicy: '隐私政策',
    privacyPopupAgree: '通过弹窗形式重新获取用户对于隐私政策的同意',
    privacyVersion: '隐私政策版本',
    privacyVersionList: '隐私政策版本列表',
    problemaDes: '问题描述',
    processMethod: '处理方式',
    processReason: '处理原因',
    processReasonDetails: '处理原因详情',
    processRecord: '处理记录',
    processReport: '处理举报',
    processSolution: '处理方案',
    processUser: '处理用户',
    processed: '已处理',
    productDetails: '商品详情',
    productTime: '生产时间',
    prohibitDecimalsAndNegative: '禁止输入小数以及负数',
    pt_PT: '葡萄牙语',
    publishInformation: '发布资讯',
    publishPosts: '发布帖子',
    pullBefore: '下拉可以刷新',
    pulling: '松开立即刷新',
    purchaseAndInstall: '购买并安装',
    pushConfiguration: '推送配置',
    pushContent: '推送内容',
    pushList: '推送列表',
    pushMode: '推送方式',
    pushNow: '立即推送',
    pushQuery: '推送查询',
    pushRecord: '推送记录',
    pushScope: '推送范围',
    pushTime: '推送时间',
    pushTimeDifferenceAsk: '你所选择的发送时间会因为时差的原因导致部分用户无法收到这一条推送。确定要保存吗？',
    pushTitle: '推送标题',
    pushed: '已推送',
    pushing: '推送中',
    quantity: '数量',
    query: '查询',
    question: '问题',
    questionInquiry: '问题查询',
    questionType: '问题类型',
    questionTypeList: '问题分类列表',
    questionTypeTemplate: '帮助中心-问题分类模板',
    quickRelease: '快速发布',
    ranking: '排名',
    ratingWarn1: '车主用户，管理后台对应所属国家/地区的智能服务控制未开启或开启后智能服务服务未过期，车辆在线且存在',
    ratingWarn2: '次及以上完整的骑行记录（每次骑行均上报骑行开始及结束事件）前提下，用户从我的骑行退出至首页时弹出',
    reUpgrade: '重新升级',
    readAgree: '阅读并同意',
    readAndAgree: '请阅读并同意',
    readAndAgreeTo: '我已阅读并同意',
    readDeleteStep: '了解我们会删除或保留的数据类型，以及任何额外保留期限',
    realname: '真实姓名',
    reasonForReport: '举报理由',
    receiveCarReminderMessage: '接收车辆消息提醒',
    rechargeAmount: '充值金额',
    rechargeChannel: '充值渠道',
    rechargeStatus: '充值状态',
    rechargeTime: '充值时间',
    recharged: '已充值',
    recipients: '收件人',
    recipientsNum: '收件人范围',
    recommended: '推荐',
    recommendedStatus: '推荐状态',
    redeemableServiceHours: '可兑换服务时长',
    redemptionMileage: '兑换里程数',
    redemptionRatio: '兑换比例',
    redemptionTime: '兑换时间',
    redirectUrl: '跳转URL',
    refreshInterval: '刷新间隔',
    refreshSend: '重发',
    refundFailed: '退款失败',
    refunded: '已退款',
    refunding: '退款中',
    refused: '已拒绝',
    registerDate: '注册时间',
    rejected: '已驳回',
    releaseContent: '发布动态',
    releaseMethod: '发布方式',
    releaseMute: '解除禁言',
    releaseTime: '发布时间:',
    released: '已发布',
    releasedBy: '发布人',
    remainServiceHavExpired: '距离智能服务到期',
    remainingAvailableMileage: '剩余可选择里程',
    remark: '备注',
    rememberPassword: '记住密码',
    reminder: '提醒',
    remove: '移除',
    removeOnlinUpgrade: '远程在线升级车辆',
    repeatNewPassword: '重复新密码',
    replaceTBOX: '更换TBOX',
    replied: '已回复',
    reply: '回复',
    report: '举报',
    reportList: '举报列表',
    reportManagement: '举报管理',
    reportReason: '举报原因',
    reportReasonDetails: '举报原因详情',
    reportReasonPlaceholder: '写下你想举报的内容，0-1500字',
    reportSearch: '举报查询',
    reportSuccessful: '举报成功，我们会尽快处理',
    reportTime: '举报时间',
    reportType: '举报类型',
    reportedContent: '被举报内容',
    reportedUser: '被举报人',
    reportedUserId: '被举报人ID',
    requestTimedOut: '请求超时了',
    resend: '重新发送',
    resendTo: '重新发送到',
    reset: '重置',
    resetItem: '重置项',
    resetTime: '智能服务重置时间',
    resetWarn: '重置后该车的智能服务免费时长将按照当前时间（浏览器时间）重新计算并生效，请确认是否重置？',
    return: '返回',
    review: '审核',
    reviewApproved: '审核通过',
    richText: '富文本',
    ro_RO: '罗马尼亚语',
    roleDescription: '角色描述',
    roleName: '角色名称',
    rolePermission: '角色权限',
    'routerTitleBinding-agreement': '绑车协议',
    routerTitleDownload: 'CFMOTO RIDE APP Download',
    routerTitleEbook: '电子书',
    routerTitleIntroduce: '介绍',
    routerTitleOrderConfirm: 'Order Confirmation',
    routerTitlePdf: 'PDF',
    ru_RU: '俄罗斯语',
    safeRemind: '为保障您的账户安全，请勿在此提交个人敏感信息，如账户密码等',
    satelliteMap: '卫星地图',
    saturday: '周六',
    save: '保存',
    saveAndPreview: '保存并预览',
    saveAsDraft: '保存为草稿',
    saveFail: '保存失败',
    savePicture: '保存图片',
    saveSettings: '保存设置',
    saveSuccess: '保存成功',
    saveVideo: '保存视频',
    scanQrcodePreview: '手机扫描下方二维码可预览',
    screenNavigationGuidance: '息屏导航引导',
    sdkStatement: 'SDK声明',
    search: '搜索',
    searchRecords: '历史搜索',
    secondaryMenu: '二级菜单',
    securityMessage: '以上信息仅用于身份验证，CFMOTO保障您的信息安全',
    securityServices: '安全服务（实时定位、电子围栏、异常告警）',
    select: '选择',
    selectAccount: '选择账号',
    selectAll: '全选',
    selectAuthentication: '选择认证',
    selectChannelType: '请选择反馈渠道',
    selectCountry: '选择国家',
    selectData: '请选择您需要删除的数据，并点击底部提交按钮以提交数据删除申请',
    selectDate: '选择日期',
    selectEnableStatus: '请选择启用状态',
    selectFeedBackState: '选择反馈处理状态',
    selectFeedbackType: '请选择反馈类型',
    selectJumpTarget: '请选择跳转目标',
    selectLanguage: '请选择语言',
    selectOneCarType: '至少选择一个车型',
    selectPoint: '重新选点',
    selectPopupFrequency: '请选择弹窗频率',
    selectPopupPosition: '请选择弹窗位置',
    selectPopupTarget: '请选择弹窗目标',
    selectPopupTime: '请选择弹窗时间',
    selectRejectReason: '请选择驳回原因',
    selectTheLanguage: '选择语言',
    selectTime: '选择时间',
    selectUser: '选择用户',
    selectVehicle: '选择车辆',
    selectedMileage: '已选择里程',
    selectedMileageRedemption: '选择兑换里程',
    selectionOfImporter: '进口商选择',
    sendNumberDescription: '有效目标设备中，亚马逊云实际成功创建了发送任务的设备数量；',
    sendNumberDescription0: '有效目标设备中，极光服务器实际成功创建了发送任务的设备数量',
    sendNumberVolume: '发送数量',
    sendTo: '发送到',
    sendType: '发送方式',
    sendUserNum: '发送人数',
    sending: '发送中',
    serial: '序号',
    seriesBackground: '系列背景图',
    seriesDesc: '系列描述',
    seriesIntroduction: '系列介绍',
    seriesName: '系列名称',
    seriesShowcase: '系列展示图',
    seriesUplodImgRule: '格式要求：jpg jpeg png，建议比例9:16，分辨率1080, 1920x1080像素，大小不超过5M',
    seriousAlarm: '严重报警',
    serviceDays: '服务天数',
    serviceDetail: '智能服务详情',
    serviceExpiration: '您的智能服务已到期',
    serviceHavExpired: '智能服务已到期',
    serviceIntroduction: '服务介绍',
    serviceReset: '智能服务重置',
    serviceText: '服务',
    settingSuccess: '设置成功',
    shareNumber: '分享数',
    sheet: '张',
    show: '查看',
    showPicturesOfVideos: '展示图片/视频',
    showToast1: '剩余里程不足兑换1天服务',
    showToast2: '兑换至少需要1天服务时长',
    showToast3: '参数不存在或为空',
    showroomModel: '展厅车型',
    showroomModelList: '展厅车型列表',
    showroomModelQuery: '展厅车型查询',
    showroomUploadRules: '图片格式要求为jpg/jpeg/png，图片比例9:19.5，大小不超过5MB，视频大小不超过50MB',
    signOut: '自动注销',
    singapore: '新加坡',
    sixMonths: '六个月',
    slideToRight: '向右滑动',
    smartServices: '智能服务',
    someUser: '部分用户',
    sort: '排序',
    source: '来源',
    sr_YU: '塞尔维亚语',
    standardAgreement: '基础服务协议状态',
    startCalculateTimeBasedata: '基础服务重置时间',
    startCalculateTimeMotoplay: 'MotoPlay重置时间',
    startChecking: '开始检测',
    startTime: '开始时间',
    statisticalTime: '统计时间',
    status: '状态',
    stepText1: '为确保您能够顺利迁移数据并使用CFMOTO RIDESYNC App，我们建议您按以下步骤操作：',
    stepText2: '1. 首先，您可以点击下方按钮【前往下载CFMOTO RIDESYNC】或直接打开Apple Store/Google Play搜索并下载CFMOTO RIDESYNC App；',
    stepText3: '2. 下载安装完成后，请打开CFMOTO RIDESYNC App，进入到登录页面。在此页面，您需要使用您已有的CFMOTO RIDE账号和密码进行登录；',
    stepText4: '3. 当您正确输入账号和密码后，App会弹出一个提示窗口询问您是否要开始数据迁移过程。当您点击确定后，数据迁移将立即启动，并且此过程是不可中断的。如果您在此步骤选择“取消”，您将无法继续登录App。',
    stepText5: '4.点击确定后数据迁移将立即启动，此过程是不可中断的。如果失败，请联系it@cfmoto.com',
    stepText6: '5. 数据迁移完成后，您将自动进入CFMOTO RIDESYNC App的车辆首页。此时，您可以开始正常使用App的所有功能，并且能够访问您之前在CFMOTO RIDE App中保留的所有数据。',
    stepText7:
      '*重要提示：请务必使用您的CFMOTO RIDE账号登录CFMOTO RIDESYNC App，以确保数据迁移的成功。如果您选择重新注册新账号或使用其他账号登录，您的数据将无法完成迁移。此外，数据迁移成功后，您原有的CFMOTO RIDE账号将不再支持登录CFMOTO RIDE App。请谨慎操作，确保您的数据安全迁移。',
    stop: '停止',
    store: '商城',
    storeAddressCountryTip: '说明：此门店地址作为用户找到您的唯一依据，请认真填写，确保地址无误',
    storeAddressDetail: '门店地址',
    storeAddressDetailTip: '例：详细地址：NO.116,Wuzhou Road, Yuhang Economic Development Zone, Hangzhou',
    storeAddressPosition: '经纬度',
    storeAddressPositionTip: '经度：经度整数部分为-180~180的整数，小数部分为不超过15位的小数\n纬度：纬度整数部分为-90~90的整数，小数部分为不超过15位的小数',
    storeBusinessType: '门店类型',
    storeImage: '门店图片',
    storeImportTemplateText: '请先下载模板，在模板文件中填写经销商门店信息然后上传文件；文件大小限制在1M以内；如提交失败，请适当减少内容或分批次上传',
    storeIntroduce: '门店介绍',
    storeList: '门店列表',
    storeMange: '门店管理',
    storeName: '门店名称',
    storeNameTip: '说明：请选择系统内支持的语言填写门店名称',
    storeQueryUserStatistics: '门店查询用户统计',
    storeRemarkName: '门店备注名称',
    storeRemarkNameTip: '说明：若系统内支持的语言不能满足您的需求，您可在此使用您想要的语言录入门店备注名称',
    storeSearch: '门店查询',
    storeServicePhone: '服务电话',
    storeServicePhoneTip: '说明：此电话用于顾客电话联系，请确保电话无误',
    storeServiceTime: '营业时间',
    storeStatistics: '门店统计',
    storeUploadImageRequire: '图片格式要求为jpg/jpeg/png，建议单张图片大小不超过5MB，单次最多导入9张 ，可多次导入,总数量不超过9张',
    storefront: '门店',
    submissionFailed: '提交失败，请重试',
    submit: '提交',
    submitAccountDeleteApply: '提交账户删除申请',
    submitDataDeleteApply: '提交数据删除申请',
    submitFeedback: '提交反馈',
    submitForReview: '提交审核',
    submitted: '已提交',
    successful: '成功',
    sunday: '周日',
    supportMapDown: '支持离线地图下载',
    supportedChannel: '支持渠道',
    sureAgree: '是否确定同意',
    sureBackApply: '确认撤回账户删除申请',
    sureDelete: '删除后将无法恢复，确定要删除吗',
    sureDeleteData: '确定删除所选数据？确定后立即删除且不可找回',
    sureDeleteSeries: '是否删除该系列',
    sureDeleteSetting: '是否确认删除该条支付设置',
    sureDeleteStoreInfo: '确认删除此门店信息？删除后，信息将无法恢复',
    sureReject: '是否确定拒绝',
    sureSuspend: '终止后将停止发送，确定要终止吗',
    suspend: '终止',
    sv_SE: '瑞典语',
    switchLanguage: '切换语言',
    system: '系统',
    systemBusy: '系统繁忙，请稍候再试',
    systemVersion: '系统版本',
    tboxInstall: 'Tbox后加装',
    tboxIntro: 'T-Box是实现车辆智能网联功能的关键设备',
    teamConfigTip: '我们将为符合以上配置条件的车辆开放Rides功能（组队越野），功能开放后需支付费用成本',
    threeMonths: '三个月',
    thursday: '周四',
    time: '时间',
    timeSend: '定时发送',
    timedOffline: '定时下线',
    timedPush: '定时推送',
    timedRelease: '定时发布',
    timedSendTime: '发送时间',
    tips: '温馨提示',
    title: '标题',
    to: '至',
    toBeReleased: '待发布',
    topMenu: '顶级菜单',
    topicContent: '话题内容',
    topicList: '话题列表',
    topicManagement: '话题管理',
    topicSearch: '话题查询',
    topicTitle: '话题名称',
    totalAndlLayoutOfStores: '门店总数及分布',
    totalClicks: '总点击次数',
    totalNumber: '总次数',
    tr_TR: '土耳其语',
    triggerNum: '触发次数',
    tuesday: '周二',
    turnOn: '打开',
    twoCarAndFourCarOfNumber: '两轮车和四轮车用户次数',
    twoCarOfNumber: '两轮车用户次数',
    twoWheelConfig: '成人两轮车辆配置',
    twoWheeler: '两轮车',
    twoWheelerAndFourWheeler: '两轮和四轮',
    twoWheelerMostClicks: '两轮最多点击车型',
    twoWheelowner: '成人两轮车主',
    type: '类别',
    typeMessage: '反馈类型',
    types: '种',
    unbind: '未绑定',
    unbindingCommitment: '解绑承诺书',
    unbindingLabelRealName: '你的真实姓名',
    unbound: '已解绑',
    understandRealtimeConditions: '接收车辆震动、电子围栏驶入驶出的车辆提醒消息，实时掌握车辆状态',
    uninstallTboxDesc: '未安装T- Box的车辆，绑定后可以查看车架号、发动机号、电子说明书等车辆基础信息。',
    unitCurrencyPer: '单位货币每',
    unitMonth: '个月',
    unlimited: '不限',
    unpaid: '未付款',
    unprocessed: '未处理',
    unresolved: '仍无法解决？点击',
    unspecified: '保密',
    upToTopics: '最多可以添加%s个话题',
    updateAuthenticationTime: '更新认证时间',
    updateBy: '更新人',
    updateSuccess: '更新成功',
    updateTime: '更新时间',
    updating: '升级中',
    upgradeAgainDescription: '已重新推送升级任务，请按照当前页面右上方【升级助手】提示，操作仪表联网升级',
    upgradeAssistant: '升级助手',
    upgradeDescription: '发现新版本，请按照当前页面右上方【升级助手】提示，操作仪表联网升级',
    upgradeSuccessful: '升级成功',
    upgradeType: '升级方式',
    upload: '上传',
    uploadDisplayPicture: '请上传展示图',
    uploadFail: '上传失败',
    uploadFailed: '上传失败，请尝试使用其他网络',
    uploadFailedOfTry: '上传失败，请重试',
    uploadFileMore1M: '上传文件大小不超过1M',
    uploadFiles: '上传文件',
    uploadImageRules1To1: '图片格式要求为jpg/jpeg/png，图片比例1:1，大小不超过5MB',
    uploadLog: '上传日志',
    uploadPicture: '上传图片',
    uploadQuantityExceed: '上传数量超出限制',
    uploadSuccessful: '上传成功',
    uploadTime: '上传时间',
    uploadTip556_740: '请上传宽高556*740的图片',
    uploadVideoRules: '仅支持视频文件单个上传，建议单个视频大小不超过50MB',
    uploadVideoRules4To3: '支持视频格式，建议比例4:3，大小不超过50MB',
    urlLink: 'URL链接',
    user: '用户',
    userAccount: '用户账号',
    userEmail: '用户邮箱',
    userGender: '用户性别',
    userId: '用户ID',
    userIdTemplate: '用户ID导入模板',
    userIdentity: '用户身份',
    userLocalTime: '终端用户时间',
    userLogin: '用户登录',
    userMobilePhone: '用户手机号',
    userModel: '用户车型',
    userName: '用户名',
    userName1: '用户名称',
    userNickname: '用户昵称',
    userNum: '用户数',
    userPhone: '手机号',
    userRealName: '用户真实姓名',
    userReply: '待用户回复',
    userStatus: '用户状态',
    userType: '用户类型',
    userUnbind: '用户解绑',
    users: '位用户',
    vacationTime: '假期时间',
    validNumberVolume: '有效目标数',
    validNumerDescription: '将推送任务所选定的目标人群，经过有效性筛选后的目标设备数量',
    validateAfter24Hours: '仅支持选择24小时后的未来时间',
    validateEmail: '邮箱格式错误，请检查',
    validateImageRadio: '图片文件格式要求：%s 图片比例%s，大小不超过%s',
    validateImageSize: '图片文件格式要求：%s，图片尺寸建议%s，大小不超过%s',
    validatePhone: '联系电话格式错误，请检查',
    validateVideo: '视频文件格式要求：%s，大小不超过%s',
    validateVin: '车架号输入错误，请检查',
    validationCodeError: '验证码错误',
    vechicleFirstBindTime: '车辆实际首绑时间',
    vehicleAlarmDetails: '车辆报警详情',
    vehicleBindDuration: '车辆绑定时长',
    vehicleBrochure: '车辆画册',
    vehicleColor: '车辆颜色',
    vehicleDetails: '车辆详情',
    vehicleDrivingLicense: '车辆行驶证',
    vehicleFaultDetails: '车辆故障详情',
    vehicleGallery: '车辆图库',
    vehicleGalleryEntranceConfiguration: 'APP机车展厅页面，车辆图库功能入口图片均取自以下配置，请确保配置完成三张图片',
    vehicleGalleryEntranceSettings: '车辆图库入口设置',
    vehicleGalleryUploadRules: '图片格式要求为jpg/jpeg/png，建议单张图片大小不超过5MB，单次最多导入10张 ，可多次导入',
    vehicleIdHomepageImage: '包含车主姓名及车架号码信息的证件主页',
    vehicleModel: '车型',
    vehicleModelAlbum: '车型画册',
    vehicleModelCategorySort: '车型类别排序',
    vehicleModelDescription: '车型说明',
    vehicleModelList: '车型列表',
    vehicleModelManagement: '车型管理',
    vehicleModelName: '车型名称',
    vehicleModelQuery: '车型查询',
    vehicleModelSeries: '车型系列',
    vehicleModelSorting: '车型排序',
    vehicleModelType: '车型类别',
    vehicleName: '车辆名称',
    vehicleNetworkEquipment: '车辆联网设备',
    vehicleOutboundCountry: '车辆出库国家',
    vehicleRemark: '车辆备注信息',
    vehicleShareInstruction: '车辆分享说明',
    vehicleShareInstructionAdd: '新增车辆分享说明',
    vehicleShareInstructionEdit: '编辑车辆分享说明',
    vehicleType: '车辆类型',
    vehicleTypeSplicing: '反馈车型',
    vehicleUnbindingInstructions: '车辆解绑申请须知',
    verifyCodeSendFail: '验证码发送失败',
    verifyCodeSendSuccess: '验证码发送成功',
    versionCode: '版本号',
    versionIntroduction: '版本介绍',
    versionManage: '版本管理',
    versionManageList: '版本管理列表',
    versionMangeTip: '注意：不允许创建大于应用市场当前上架版本号的版本！运维人员需等待最新版本在Google Play或App Store上架后，分别创建最新版本号对应的版本记录，不允许提前创建记录。',
    versionPattern: '版本号只可输入0~999的整数',
    versionRequired: '版本号不可为空',
    vhDataBasicService: '车辆数据基础服务',
    video: '视频',
    videoContent: '视频内容',
    videoCover: '视频封面',
    videoDetail: '视频详情',
    videoDisplayImages: '视频展示图',
    videoFile: '视频文件',
    videoGuide: '视频引导配置',
    videoImageValidate: '图片文件格式要求：png jpg jpeg，图片比例16:9，大小不超过5MB',
    videoList: '视频列表',
    videoMaxSizeValidate: '视频大小不能超过150MB',
    videoSizeExceed: '请上传宽高为%s的视频',
    viewAllComment: '查看全部评论',
    viewCount: '浏览数',
    viewCurrentLocation: '打开APP随时查看车辆当前位置',
    viewCurrentLocation2: '打开APP随时查看车辆当前位置，方便近距离寻车',
    viewDetails: '查看详情',
    viewFeedBackRecords: '查看反馈记录',
    viewLocation: '打开APP随时查看车辆位置',
    viewModel: '查看车型',
    viewPush: '查看推送',
    viewSeries: '查看系列',
    viewVehicleInfomation: '支持查看车辆的每日骑行轨迹、里程、时长、极速等信息',
    views: '观看量',
    vin: '车架号',
    virginia: '弗吉尼亚  ',
    waitForReview: '待审核',
    waitUploading: '上传中，请稍候',
    waitingManualReview: '待人工复审',
    waitingOnline: '待上线',
    waitingPush: '待推送',
    wednesday: '周三',
    whatOTA: '关于OTA',
    whyUseNavigation: '如何使用导航',
    whyUseSetting: '如何进行APP通用设置',
    withCountry: '所在国家/地区(IP)',
    withInformation: '有信息',
    withTBOX: '有TBOX',
    withdrawn: '已撤回',
    withoutCarOfNumber: '无车用户次数',
    withoutTBOX: '无TBOX',
    writeAccountToPass: '填写账户信息并完成身份验证',
    year: '年',
    yes: '是',
    youHaveFeedbackMessage: '您有**条用户反馈未有效跟进，请及时处理',
    youthVehicleOwner: '非成人车主',
    yoyGrowth: '同比上涨',
    zh_CN: '中文',
  },
};
